module.exports = __webpack_public_path__ + "static/img/智界R7.79985357.png";